import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';

import { Options, useOption } from 'lib';
import {
  HotelImportStatus as HotelImportStatusType,
  HotelImportStatus_hotelImport$key,
} from '__generated__/HotelImportStatus_hotelImport.graphql';

type Props = {
  hotelImport: HotelImportStatus_hotelImport$key;
};

export const optionsConfig: Options<HotelImportStatusType> = {
  PENDING: {
    label: 'Importuojama',
    color: 'info',
  },
  COMPLETE: {
    label: 'Pabaigta',
    color: 'success',
  },
  SKIPPED: {
    label: 'Praleista',
    color: 'warning',
  },
};

const HotelImportStatus: FC<Props> = ({ hotelImport }) => {
  const { status } = useFragment(
    graphql`
      fragment HotelImportStatus_hotelImport on HotelImport {
        status
      }
    `,
    hotelImport
  );

  const { label, color } = useOption(status, optionsConfig);

  return <Box sx={{ color }}>{label}</Box>;
};

export default HotelImportStatus;
